module.exports = __webpack_public_path__ + "img/drive-panel-aircon-off.979b20c5.svg";